import { render, staticRenderFns } from "./qrCodeEntry.vue?vue&type=template&id=36f20b38&scoped=true&"
import script from "./qrCodeEntry.vue?vue&type=script&lang=js&"
export * from "./qrCodeEntry.vue?vue&type=script&lang=js&"
import style0 from "./qrCodeEntry.vue?vue&type=style&index=0&id=36f20b38&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f20b38",
  null
  
)

export default component.exports